/*
 * @Author: wangshengqiang
 * @Date: 2021-04-26 11:29:41
 * @LastEditTime: 2021-06-11 10:45:57
 * @LastEditors: wangshengqiang
 * @Description: 资料按钮组件
 */
import React, { useState, useContext } from 'react';
import classnames from 'classnames';
import { ModuleContext } from '@/components/BaseModule';
import { getLocalClick } from '@/components/EventBtn/handleEvent';
import './index.less';
const IconButton = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    attrs,
    events,
    label
  } = props;
  const {
    enable,
    fontClass
  } = attrs;
  const context = useContext(ModuleContext) || {};
  const {
    id
  } = context; // const data = { buttonCode: id };
  // const onClickFetch = useFetchClick(data);

  const onClickLocal = getLocalClick(events, (opts = {}, next) => {
    const {
      type,
      behavior
    } = opts;

    if (type === 'behavior' && behavior === 'continue') {
      return () => {// Modal.hide();
        // onClickFetch();
      };
    }

    return next;
  });

  const onClick = () => {
    onClickLocal();
  };

  const cls = classnames({
    'components-customer-service-render': true
  });
  const iconCls = classnames({
    'iconfont-button': true,
    [fontClass]: !!fontClass
  });
  if (!enable) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: cls,
    onClick: () => onClick()
  }, /*#__PURE__*/React.createElement("i", {
    className: iconCls
  }), /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, label));
});
export default IconButton;